export default () => {
    return useCookie<string>('cjevent', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
